export const ONBOARDING_CALL_CALENDLY_BASE = 'https://calendly.com/vacationtrackerdaniela/letstalk'

export type OnboardingCallCtaPlacement = 'onboarding_modal' | 'profile_menu' | 'dashboard_banner'

const UTM = {
  utm_source: 'vacation-tracker-app',
  utm_medium: 'in_app',
  utm_campaign: 'onboarding-1to1',
} as const

/**
 * Inline iframe URL so Calendly can `postMessage` the parent on `calendly.event_scheduled`.
 * Requires `embed_domain` + `embed_type` (see Calendly “parent window notifications”).
 */
export function buildOnboardingCallCalendlyEmbedUrl(placement: OnboardingCallCtaPlacement): string {
  const embedDomain = typeof window !== 'undefined' ? window.location.host : ''
  const params = new URLSearchParams({
    ...UTM,
    utm_content: placement,
    embed_domain: embedDomain,
    embed_type: 'Inline',
  })
  return `${ONBOARDING_CALL_CALENDLY_BASE}?${params.toString()}`
}
